import { render, staticRenderFns } from "./WebPartPageCol.vue?vue&type=template&id=c088e820"
import script from "./WebPartPageCol.ts?vue&type=script&lang=ts&external"
export * from "./WebPartPageCol.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports